import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { FeedService } from '../../services/feed.service';
import { LoginService } from 'src/app/core/services/login.service';
import { EditReplyDialogComponent } from '../edit-reply-dialog/edit-reply-dialog.component';
import { DocumentViewerComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component';

@Component({
  selector: 'app-reply',
  templateUrl: './reply.component.html',
  styleUrls: ['./reply.component.scss'],
})
export class ReplyComponent implements OnInit {
  @Input() reply: any;
  @Output() replyClicked = new EventEmitter<any>(); // Add this
  @Output() feedStatusChanged = new EventEmitter<Boolean>();

  @Input() commentIndex: number;
  loginDetails: any;
  @Input() depth: number = 0;
  @Input() isLast: boolean = false;
  @Input() level: number = 0;

  @Output() getCommentsReply = new EventEmitter<{
    feedID: any;
    likedsec: any;
    feedType: any;
  }>();

  constructor(
    private dialog: MatDialog,
    private _dialog: MatDialog,
    private toast: ToastService,
    private feedService: FeedService,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();
  }

  canEditOrDelete(reply: any): boolean {
    return this.isReplyOwner(reply) || this.isAdmin();
  }

  isReplyOwner(reply: any): boolean {
    return [
      reply?.dental_admin_id,
      reply?.dental_practice_id,
      reply?.dental_supplier_id,
      reply?.dental_professional_id,
    ].includes(this.loginDetails?.id);
  }

  isAdmin(): boolean {
    return this.loginDetails.type === 'ADMIN';
  }

  toggleReplyed(reply: any) {
    this.replyClicked.emit({ commentIndex: this.commentIndex, reply });
  }

  handleFeedStatusChange() {
    this.feedStatusChanged.emit(true);
  }

  deleteReply(replyDelete: any) {

    

    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: replyDelete?.id,
        name: 'Reply',
      },
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response === 'yes') {
        // this.feedStatusChanged.emit(true);
        this.feedService.deleteNewsfeedReply(replyDelete?.id).then(() => {
          this.toast.openSnackBar(' reply deleted successfully');

          let likedsec = 'Send';
          // let feedID = replyDelete?.jobs
          //   ? replyDelete?.jobs.id
          //   : replyDelete?.newsfeeds.id;

               let feedID = replyDelete?.jobs?.id 
          ?? replyDelete?.newsfeeds?.id 
          ?? replyDelete?.courses?.id;


          // let feedType = replyDelete?.jobs ? 'JOBS' : 'feed';
           let feedType = replyDelete?.jobs ? "JOBS":
            replyDelete?.newsfeeds ? "feed":
             replyDelete?.courses ? "LEARNHUB":
             null;

          this.getCommentsReply.emit({ feedID, likedsec, feedType });
        });
      }
    });
  }

  editReply(reply: any) {
    const dialogRef = this.dialog.open(EditReplyDialogComponent, {
      width: '400px',
      data: {
        reply: reply.reply_text,
        id: reply.id,
        reply_attachments: reply.reply_attachments,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        reply.reply_text = result.reply_text;
        reply.reply_attachments = result.reply_attachments;
      }
    });
  }

  viewcommentDocuments(document, index: number): void {
    this._dialog.open(DocumentViewerComponent, {
      width: '80%',
      panelClass: ['custom-modal'],
      data: {
        documents: document,
        initialIndex: index,
      },
    });
  }

  onGetCommentsReplyFromNested($event: {
    feedID: any;
    likedsec: any;
    feedType: any;
  }) {
    this.getCommentsReply.emit($event); // bubble up
  }
}
